module.exports = __webpack_public_path__ + "static/media/userAvatarBlue.5c042d34.svg";